import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export const ScenarioComparison = ({
  scenarios,
  formatPrice,
  showVat
}) => {
  const getVatAdjustedPrice = price => {
    return showVat ? price : Math.round(price / 1.25);
  };
  const comparisonItems = [{
    name: 'Manifold(er) & antal kredse',
    key: 'manifold'
  }, {
    name: 'Rørdimension & meter',
    key: 'pipes'
  }, {
    name: 'Termostater & zoner',
    key: 'thermostats'
  }, {
    name: 'Shunt/fordeler/pumper',
    key: 'pump'
  }, {
    name: 'Ventilation',
    key: 'ventilation'
  }, {
    name: 'Garanti & service',
    values: {
      good: '2 års standard garanti',
      better: '3 års udvidet garanti',
      best: '5 års fuld garanti inkl. service'
    }
  }, {
    name: 'Energi & komfort',
    values: {
      good: 'Basis styring, manuel justering',
      better: 'Zonebaseret styring, støjniveau 30dB',
      best: 'Fuld automation, støjniveau <25dB, fjernbetjening'
    }
  }];
  return <section className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-69">
      <div className="p-6" data-id="element-70">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-71">
          Sammenligning af scenarier
        </h2>
        <div className="overflow-x-auto" data-id="element-72">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-73">
            <thead className="bg-gray-50" data-id="element-74">
              <tr data-id="element-75">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-76">
                  Specifikation
                </th>
                {Object.keys(scenarios).map(key => <th key={key} scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-77">
                    {scenarios[key].name}
                  </th>)}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-78">
              {comparisonItems.map((item, index) => <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-79">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-80">
                    {item.name}
                  </td>
                  {Object.keys(scenarios).map(key => <td key={key} className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-81">
                      {item.key ? scenarios[key][item.key] : item.values[key]}
                    </td>)}
                </tr>)}
              <tr className="bg-gray-50" data-id="element-82">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-83">
                  Samlet pris
                </td>
                {Object.keys(scenarios).map(key => <td key={key} className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900" data-id="element-84">
                    {formatPrice(getVatAdjustedPrice(scenarios[key].basePrice))}
                  </td>)}
              </tr>
              <tr data-id="element-85">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-86">
                  Månedlig ydelse
                </td>
                {Object.keys(scenarios).map(key => <td key={key} className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-87">
                    Fra {formatPrice(scenarios[key].monthlyPayment)}/md
                  </td>)}
              </tr>
              <tr className="bg-gray-50" data-id="element-88">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-89">
                  Leveringstid (ETA)
                </td>
                {Object.keys(scenarios).map(key => <td key={key} className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-90">
                    {scenarios[key].eta}
                  </td>)}
              </tr>
              <tr data-id="element-91">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-92">
                  Lagerstatus
                </td>
                {Object.keys(scenarios).map(key => <td key={key} className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-93">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${scenarios[key].stock === 'På lager' ? 'bg-green-100 text-green-800' : scenarios[key].stock === 'Delvist på lager' ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-94">
                      {scenarios[key].stock}
                    </span>
                  </td>)}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>;
};